var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", [
        _c("div", { attrs: { id: "top_content" } }, [
          _c("div", { staticClass: "top_img" }, [
            _c("img", { attrs: { src: this.getImage("top/img_hero.png") } }),
            _vm._v(" "),
            _c("div", { staticClass: "top_text" }, [
              _vm._v("収納家具を1ミリ単位でカスタムオーダー")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top_banner" }, [
            _c("img", {
              attrs: { src: this.getImage("top/HAKOTAN_banner.png") }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title_text" }, [
            _vm._v("暮らしに合わせてジャストフィットする収納家具")
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1)
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main_content wrapper" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c("dd-content", { ref: "mainContent" })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title_message" }, [
      _c("p", [
        _vm._v(
          "ハコタンは、あなたのお部屋にピッタリの収納家具をオンラインでカスタムオーダーできます。"
        ),
        _c("br"),
        _vm._v(
          "\n           吊戸棚、食器棚、壁面収納など豊富なラインナップをご用意しており、"
        ),
        _c("br"),
        _vm._v(
          "\n           1ミリ単位でのサイズや、カラーをカスタマイズすることができます。"
        ),
        _c("br"),
        _vm._v(
          "\n           暮らしにジャストフィットするあなただけの快適な収納家具をお届けします。"
        ),
        _c("br")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step_area" }, [
      _c("div", { staticClass: "step_content" }, [
        _c("div", { staticClass: "step_block" }, [
          _c("div", { staticClass: "step_first" }, [
            _vm._v("購入までの３ステップ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "step_shape" }, [
            _vm._v("設置場所のサイズ測定")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "step_shape" }, [
            _vm._v("商品を選びカスタマイズ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "step_shape" }, [_vm._v("ご注文を確定")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-736fc907", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736fc907","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcTop.vue
// module id = null
// module chunks = 